import { MtFormContainer } from '@presentation/components';
import { ContactFormController } from '../../ContactFormController';

export const MtContactPageController = () => {
  return (
    <MtFormContainer>
      <ContactFormController />
    </MtFormContainer>
  );
};
